import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { states } from "constants/apiUrls";

const stateListApi = createApi({
  reducerPath: "stateList",
  baseQuery: fetchBaseQuery({ baseUrl: "" }),
  endpoints: (builder) => ({
    stateList: builder.query<
      PaginatedResonse<CountryType>,
      { countryCode: string }
    >({
      query: (arg) => {
        const { countryCode } = arg;
        const token = localStorage.getItem("token");
        const mandatoryHeaders: any = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
        };

        // Add authorization if token exists
        if (token) {
          try {
            mandatoryHeaders.Authorization = `Bearer ${JSON.parse(token)}`;
          } catch (e) {
            // Failed to parse token
          }
        }

        return {
          url: states(countryCode),
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useStateListQuery, useLazyStateListQuery } = stateListApi;
export default stateListApi;
